"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnhancerStyle = getEnhancerStyle;
exports.getInputContainerStyle = getInputContainerStyle;
exports.getInputStyle = getInputStyle;
exports.getRootStyle = getRootStyle;

var _utils = require("../utils");

var _style = require("../utils/style");

const font = {
  fontSize: '1rem',
  lineHeight: '1'
};

function getEnhancerBorderRadius(position, radius) {
  return {
    start: {
      borderTopLeftRadius: radius,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: radius
    },
    end: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: radius,
      borderBottomRightRadius: radius,
      borderBottomLeftRadius: 0
    }
  }[position];
}

function getEnhancerBorderWidth(position) {
  return {
    start: {
      borderTopWidth: '0px',
      borderRightWidth: '1px',
      borderBottomWidth: '0px',
      borderLeftWidth: '0px'
    },
    end: {
      borderTopWidth: '0px',
      borderRightWidth: '0px',
      borderBottomWidth: '0px',
      borderLeftWidth: '1px'
    }
  }[position];
}

function getEnhancerColor({
  $disabled,
  $error,
  $theme
}) {
  if ($disabled) {
    return $theme.colors.inputTextDisabled;
  } else if ($error) {
    return $theme.colors.negative400;
  } else {
    return $theme.colors.grey70;
  }
}

function getInputStyle({
  $theme
}) {
  return { ...font,
    color: $theme.colors.grey70,
    paddingLeft: '1rem',
    paddingRight: '1rem',
    height: 'auto',
    '::placeholder': {
      color: $theme.colors.grey50
    }
  };
}

function getInputContainerStyle(styleArgs) {
  const {
    $disabled,
    $theme
  } = styleArgs;
  return {
    backgroundColor: $disabled ? $theme.colors.grey10 : $theme.colors.white
  };
}

function getRootStyle(styleArgs) {
  const {
    $theme
  } = styleArgs;
  const borderWidth = '1px';
  const borderColor = (0, _utils.getBorderColor)(styleArgs);
  return {
    height: '3rem',
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    borderTopColor: borderColor,
    borderRightColor: borderColor,
    borderBottomColor: borderColor,
    borderLeftColor: borderColor,
    ...(0, _style.buildBorderStyle)('Width', borderWidth),
    ...(0, _style.buildBorderRadiusStyle)($theme.sizing.scale100)
  };
}

function getEnhancerStyle(styleArgs) {
  const {
    $error,
    $position,
    $theme
  } = styleArgs;
  const borderStyle = 'solid';
  const borderColor = (0, _utils.getBorderColor)(styleArgs);
  return { ...font,
    backgroundColor: $error ? $theme.colors.negative100 : $theme.colors.grey10,
    paddingLeft: '1.125rem',
    paddingRight: '1.125rem',
    borderTopColor: borderColor,
    borderRightColor: borderColor,
    borderBottomColor: borderColor,
    borderLeftColor: borderColor,
    borderTopStyle: borderStyle,
    borderRightStyle: borderStyle,
    borderBottomStyle: borderStyle,
    borderLeftStyle: borderStyle,
    color: getEnhancerColor(styleArgs),
    ...getEnhancerBorderWidth($position),
    ...getEnhancerBorderRadius($position, $theme.sizing.scale100),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  };
}